// extracted by mini-css-extract-plugin
export default {"container":"x2-z"};